import { formatNumberWithAbbreviation } from "@memorang/helpers/common";
import { Trans, useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { LeaderboardRankRow } from "./LeaderboardRankRow";
import type { LeaderboardItem } from "./types";

type Props = LeaderboardItem & {
	xpGap: number;
	numUsersToDisplay?: number;
};

export const LeaderboardCurrentUserBar = ({
	rank,
	username,
	xp,
	xpGap,
	numUsersToDisplay = 10,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const showGapHint = xpGap > 0 && rank > 1;

	return (
		<Box
			paddingTop={12}
			paddingBottom={12}
			borderTopWidth={1}
			borderTopColor={theme.colors.surfaceVariant}
			backgroundColor={theme.colors.surface}
		>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="space-between"
				paddingHorizontal={16}
				paddingBottom={8}
			>
				<Text
					variant="labelSmall"
					style={{ color: theme.colors.onSurfaceVariant }}
				>
					{t("leaderboard.yourPosition")}
				</Text>
				{showGapHint ? (
					<Text variant="labelSmall" style={{ color: theme.colors.secondary }}>
						<Trans
							i18nKey={
								rank <= numUsersToDisplay
									? "leaderboard.footer.gapHintToPass"
									: "leaderboard.footer.gapHintFromPodium"
							}
							values={
								rank <= numUsersToDisplay
									? {
											value: formatNumberWithAbbreviation(xpGap),
											rank: rank - 1,
										}
									: { value: formatNumberWithAbbreviation(xpGap) }
							}
							components={{
								num: (
									<Text
										variant="labelSmall"
										style={[
											styles.gapEmphasis,
											{ color: theme.colors.primary },
										]}
									>
										{""}
									</Text>
								),
								unit: (
									<Text
										variant="labelSmall"
										style={{ color: theme.colors.primary }}
									>
										{""}
									</Text>
								),
								rest: (
									<Text
										variant="labelSmall"
										style={{ color: theme.colors.secondary }}
									>
										{""}
									</Text>
								),
							}}
						/>
					</Text>
				) : null}
			</Box>
			<LeaderboardRankRow
				rank={rank}
				username={username}
				xp={xp}
				isCurrentUser
				showDivider={false}
			/>
		</Box>
	);
};

const styles = StyleSheet.create({
	gapEmphasis: {
		fontWeight: "600",
	},
});
